import { createHashRouter, Navigate } from "react-router-dom";
import App from "./App";
import { AddS3VaultWizard } from "./components/lifecycle/AddS3VaultWizard";
import { ImportBackupWizard } from "./components/lifecycle/ImportBackupWizard";
import { MasterSetupWizard } from "./components/lifecycle/MasterSetupWizard";
import { MasterUnlockScreen } from "./components/lifecycle/MasterUnlockScreen";
import { RootRedirect } from "./components/lifecycle/RootRedirect";
import { Browser } from "./components/browser/Browser";
import { Settings } from "./components/settings/Settings";
import { GalleryViewer } from "./components/gallery/GalleryViewer";

export const router = createHashRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <RootRedirect /> },
      { path: "setup", element: <Navigate to="/setup/1" replace /> },
      { path: "setup/:step", element: <MasterSetupWizard /> },
      { path: "import", element: <ImportBackupWizard /> },
      { path: "master", element: <MasterUnlockScreen /> },
      { path: "vaults/add", element: <Navigate to="/vaults/add/1" replace /> },
      { path: "vaults/add/:step", element: <AddS3VaultWizard /> },
      { path: "v/:vaultId/~/*", element: <Browser /> },
      { path: "v/:vaultId/view/*", element: <GalleryViewer /> },
      { path: "settings", element: <Settings /> },
      { path: "settings/:section", element: <Settings /> },
    ],
  },
]);
